// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Single blog post css */

:root {
  --nv-primary-accent: #916db0;
  --nv-secondary-accent: #916db0;
  --nv-site-bg: #ffffff;
  --nv-light-bg: #ededed;
  --nv-dark-bg: #14171c;
  --nv-text-color: #282828;
  --nv-text-dark-bg: #ffffff;
  --nv-c-1: #77b978;
  --nv-c-2: #ff4560;
  --nv-fallback-ff: Arial, Helvetica, sans-serif;
}

figure.wp-block-image {
  margin: 0px;
}

.wp-block-image .aligncenter {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.nv-comment-content a,
.nv-content-wrap a:not(.button):not(.wp-block-file__button) {
  text-decoration: underline;
}
a {
  cursor: pointer;
  color: var(--nv-primary-accent);
  text-decoration: none;
}

.wp-block-image {
  margin: 30px 0px;
}

.wp-block-image img {
  max-width: 760px !important;
  object-fit: contain;
  height: auto;
  padding-bottom: 16px;
}

.wp-element-caption {
  font-style: italic;
  font-size: 15px;
  color: #707070;
}

blockquote {
  margin: 30px;
}

cite {
  font-style: italic;
  color: #707070;
}

p {
  margin-bottom: 30px;
}

/* if screen smaller than 760 */
@media screen and (max-width: 760px) {
  .wp-block-image img {
    width: -webkit-fill-available;
  }
}

.wp-block-embed__wrapper {
  position: relative;
}

.nv-iframe-embed {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}

.nv-iframe-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wp-block-embed iframe {
  max-width: 100%;
}

/* Table of contents */
div#ez-toc-container {
  padding-right: 20px;
  margin: auto;
}

#ez-toc-container {
  background: #f9f9f9;
  border: 1px solid #aaa;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  display: table;
  margin-bottom: 1em;
  padding: 10px;
  position: relative;
  width: auto;
}
.ez-toc-container-direction {
  direction: ltr;
}

.ez-toc-title-container {
  display: table;
  width: 100%;
}

div#ez-toc-container p.ez-toc-title {
  font-weight: 500;
}

div#ez-toc-container p.ez-toc-title {
  font-size: 120%;
}
div#ez-toc-container p.ez-toc-title {
  display: contents;
}
#ez-toc-container p.ez-toc-title {
  text-align: left;
  line-height: 1.45;
  margin: 0;
  padding: 0;
}
.ez-toc-title,
.ez-toc-title-toggle {
  display: inline;
  text-align: left;
  vertical-align: middle;
}

#ez-toc-container a.ez-toc-toggle {
  display: flex;
  align-items: center;
  color: #444;
  background: inherit;
  border: inherit;
}
#ez-toc-container a {
  color: #444;
  box-shadow: none;
  text-decoration: none;
  text-shadow: none;
  display: inline-flex;
  align-items: stretch;
  flex-wrap: nowrap;
}

.nv-comment-content a:hover,
.nv-content-wrap a:not(.button):not(.wp-block-file__button):hover {
  text-decoration: none;
}
.nv-comment-content a,
.nv-content-wrap a:not(.button):not(.wp-block-file__button) {
  text-decoration: underline;
}
.ez-toc-btn-default:focus,
.ez-toc-btn-default:hover {
  background-color: #e0e0e0;
  background-position: 0 -15px;
}
.ez-toc-btn-default.active,
.ez-toc-btn-default:active,
.ez-toc-btn-default:focus,
.ez-toc-btn-default:hover {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
}
.ez-toc-btn:focus,
.ez-toc-btn:hover {
  color: #333;
  text-decoration: none;
}
.ez-toc-btn:focus {
  outline: #333 dotted thin;
  outline: -webkit-focus-ring-color auto 5px;
  outline-offset: -2px;
}
a:focus,
a:hover {
  text-decoration: underline;
  color: var(--nv-secondary-accent);
}
.ez-toc-pull-right {
  float: right !important;
  margin-left: 10px;
}
.ez-toc-btn-xs {
  padding: 1px 5px;
}
.ez-toc-btn-sm,
.ez-toc-btn-xs {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}

/* Video css */
figure.wp-block-video {
  margin: 0px;
}

.wp-block-video video {
  max-width: 760px;
  object-fit: contain;
  height: auto;
}

/* Image gallery css */
.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  a,
.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image)
  img {
  width: 100%;
  flex: 1 0 0%;
  height: 100%;
  object-fit: cover;
}

.wp-block-gallery.has-nested-images figure.wp-block-image img {
  display: block;
  height: auto;
  max-width: 100% !important;
  width: auto;
}

.wp-block-image.has-custom-border img,
.wp-block-image img {
  box-sizing: border-box;
}
.wp-block-image img {
  height: auto;
  max-width: 100%;
  vertical-align: bottom;
}

html :where(img[class*="wp-image-"]) {
  height: auto;
  max-width: 100%;
}

@media (min-width: 600px) {
  .wp-block-gallery.has-nested-images.columns-default
    figure.wp-block-image:not(#individual-image) {
    width: calc(
      33.33% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667
    );
  }
}

.wp-block-gallery.has-nested-images.is-cropped
  figure.wp-block-image:not(#individual-image) {
  align-self: inherit;
}
.wp-block-gallery.has-nested-images
  figure.wp-block-image:not(#individual-image) {
  width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) / 2);
  margin: 0;
}
.wp-block-gallery.has-nested-images figure.wp-block-image {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  position: relative;
  flex-direction: column;
  max-width: 100%;
  box-sizing: border-box;
}
body .is-layout-flex > * {
  margin: 0;
}

figure {
  margin: 0 0 1em;
}

figure.wp-block-gallery {
  margin-bottom: 30px;
}

figure.wp-block-gallery.has-nested-images {
  align-items: normal;
}

.wp-block-gallery.wp-block-gallery-1 {
  --wp--style--unstable-gallery-gap: var(
    --wp--style--gallery-gap-default,
    var(--gallery-block--gutter-size, var(--wp--style--block-gap, 0.5em))
  );
  gap: var(
    --wp--style--gallery-gap-default,
    var(--gallery-block--gutter-size, var(--wp--style--block-gap, 0.5em))
  );
}

body .is-layout-flex {
  flex-wrap: wrap;
  align-items: center;
}

body .is-layout-flex {
  display: flex;
}

/* Button css */
.wp-block-themeisle-blocks-button-group.align-center-desktop,
.wp-block-themeisle-blocks-button-group.align-center {
  justify-content: center;
}

.wp-block-themeisle-blocks-button-group {
  --padding: 16px 30px;
  --padding-tablet: var(--padding);
  --padding-mobile: var(--padding-tablet);
  --font-size: var(--btnfs, var(--bodyfontsize, 16px));
  --spacing: 20px;
  gap: var(--spacing);
}

.wp-block-themeisle-blocks-button-group {
  display: flex;
  flex-wrap: wrap;
}

.wp-block-themeisle-blocks-button-group .wp-block-themeisle-blocks-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wp-block-buttons > .wp-block-button {
  display: inline-block;
  margin: 0;
}

.wp-block-themeisle-blocks-button-group
  .wp-block-themeisle-blocks-button:is(.wp-block-button)
  :is(div, span, a).wp-block-button__link {
  padding: var(--padding);
  font-size: var(--font-size);
}

/* .wp-block-button__link:not(:hover) {
  background: var(--nv-primary-accent);
} */

.wp-block-button a {
  text-decoration: none !important;
}

.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  text-decoration-line: none;
  text-decoration-thickness: initial;
  text-decoration-style: initial;
  text-decoration-color: initial;
  padding: calc(0.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em;
}

.btn,
.button,
.wp-block-button a,
input[type="button"],
input[type="submit"] {
  font-size: 0.8em;
  font-weight: 600;
  padding: 8px 12px;
  transition: all 0.15s ease-in-out;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 3px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  text-transform: uppercase;
  cursor: pointer;
  line-height: normal;
  font-family: inherit;
}

.btn,
.button,
.wp-block-button a,
input[type="button"],
input[type="submit"] {
  font-size: 0.8em;
  font-weight: 600;
  padding: 8px 12px;
  transition: all 0.15s ease-in-out;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 3px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  text-transform: uppercase;
  cursor: pointer;
  line-height: normal;
  font-family: inherit;
}

.wp-block-button__link {
  color: #fff;
  background-color: #32373c;
  border-radius: 9999px;
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
  box-shadow: none;
  text-decoration: none;
  padding: calc(0.667em + 2px) calc(1.333em + 2px);
  font-size: 1.125em;
}
:where(.wp-block-button__link) {
  border-radius: 9999px;
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
  box-shadow: none;
  padding: calc(0.667em + 2px) calc(1.333em + 2px);
  text-decoration: none;
}

.wp-block-themeisle-blocks-button-group
  .wp-block-themeisle-blocks-button:is(.wp-block-button)
  :is(div, span, a).wp-block-button__link {
  padding: 16px 32px;
}

.wp-block-themeisle-blocks-button.wp-block-button {
  margin: 20px;
}

img.lazyload {
  width: 100%;
}

/* Quick Answers FAQ Section Styling */
/* Using stable class name to avoid MUI hash changes */
.blog-post-content details {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fafafa;
  transition: all 0.2s ease;
}

.blog-post-content details:hover {
  border-color: #916db0;
  box-shadow: 0 2px 8px rgba(145, 109, 176, 0.1);
}

.blog-post-content details[open] {
  background: #ffffff;
  border-color: #916db0;
  box-shadow: 0 2px 12px rgba(145, 109, 176, 0.15);
}

.blog-post-content details summary {
  cursor: pointer;
  user-select: none;
  list-style: none;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #282828;
  transition: color 0.2s ease;
}

/* Remove default disclosure triangle */
.blog-post-content details summary::-webkit-details-marker {
  display: none;
}

/* Custom expansion icon */
.blog-post-content details summary::before {
  content: "▶";
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 12px;
  font-size: 12px;
  color: #916db0;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.blog-post-content details[open] summary::before {
  transform: rotate(90deg);
}

.blog-post-content details summary:hover {
  color: #916db0;
}

/* H3 inside summary should not have default margins */
.blog-post-content details summary h3 {
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  display: inline;
}

/* Content inside details (when expanded) */
.blog-post-content details p,
.blog-post-content details ul,
.blog-post-content details ol {
  margin-top: 12px;
  margin-bottom: 8px;
  padding-left: 32px;
  color: #444;
  line-height: 1.6;
}

.blog-post-content details ul,
.blog-post-content details ol {
  padding-left: 52px;
}

.blog-post-content details li {
  margin-bottom: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Blog/singleBlog.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;EAC7C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;;EAIE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;;EAEE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;;;;;;EAME,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;IAEE;;KAEC;EACH;AACF;;AAEA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mEAAmE;EACnE,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;GAGC;EACD;;;GAGC;AACH;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;;EAEE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,uCAAuC;EACvC,oDAAoD;EACpD,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;AACX;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B;EAC9B,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC,sDAAsD;AACtD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* Single blog post css */\n\n:root {\n  --nv-primary-accent: #916db0;\n  --nv-secondary-accent: #916db0;\n  --nv-site-bg: #ffffff;\n  --nv-light-bg: #ededed;\n  --nv-dark-bg: #14171c;\n  --nv-text-color: #282828;\n  --nv-text-dark-bg: #ffffff;\n  --nv-c-1: #77b978;\n  --nv-c-2: #ff4560;\n  --nv-fallback-ff: Arial, Helvetica, sans-serif;\n}\n\nfigure.wp-block-image {\n  margin: 0px;\n}\n\n.wp-block-image .aligncenter {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n\n.nv-comment-content a,\n.nv-content-wrap a:not(.button):not(.wp-block-file__button) {\n  text-decoration: underline;\n}\na {\n  cursor: pointer;\n  color: var(--nv-primary-accent);\n  text-decoration: none;\n}\n\n.wp-block-image {\n  margin: 30px 0px;\n}\n\n.wp-block-image img {\n  max-width: 760px !important;\n  object-fit: contain;\n  height: auto;\n  padding-bottom: 16px;\n}\n\n.wp-element-caption {\n  font-style: italic;\n  font-size: 15px;\n  color: #707070;\n}\n\nblockquote {\n  margin: 30px;\n}\n\ncite {\n  font-style: italic;\n  color: #707070;\n}\n\np {\n  margin-bottom: 30px;\n}\n\n/* if screen smaller than 760 */\n@media screen and (max-width: 760px) {\n  .wp-block-image img {\n    width: -webkit-fill-available;\n  }\n}\n\n.wp-block-embed__wrapper {\n  position: relative;\n}\n\n.nv-iframe-embed {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n}\n\n.nv-iframe-embed iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.wp-block-embed iframe {\n  max-width: 100%;\n}\n\n/* Table of contents */\ndiv#ez-toc-container {\n  padding-right: 20px;\n  margin: auto;\n}\n\n#ez-toc-container {\n  background: #f9f9f9;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);\n  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);\n  display: table;\n  margin-bottom: 1em;\n  padding: 10px;\n  position: relative;\n  width: auto;\n}\n.ez-toc-container-direction {\n  direction: ltr;\n}\n\n.ez-toc-title-container {\n  display: table;\n  width: 100%;\n}\n\ndiv#ez-toc-container p.ez-toc-title {\n  font-weight: 500;\n}\n\ndiv#ez-toc-container p.ez-toc-title {\n  font-size: 120%;\n}\ndiv#ez-toc-container p.ez-toc-title {\n  display: contents;\n}\n#ez-toc-container p.ez-toc-title {\n  text-align: left;\n  line-height: 1.45;\n  margin: 0;\n  padding: 0;\n}\n.ez-toc-title,\n.ez-toc-title-toggle {\n  display: inline;\n  text-align: left;\n  vertical-align: middle;\n}\n\n#ez-toc-container a.ez-toc-toggle {\n  display: flex;\n  align-items: center;\n  color: #444;\n  background: inherit;\n  border: inherit;\n}\n#ez-toc-container a {\n  color: #444;\n  box-shadow: none;\n  text-decoration: none;\n  text-shadow: none;\n  display: inline-flex;\n  align-items: stretch;\n  flex-wrap: nowrap;\n}\n\n.nv-comment-content a:hover,\n.nv-content-wrap a:not(.button):not(.wp-block-file__button):hover {\n  text-decoration: none;\n}\n.nv-comment-content a,\n.nv-content-wrap a:not(.button):not(.wp-block-file__button) {\n  text-decoration: underline;\n}\n.ez-toc-btn-default:focus,\n.ez-toc-btn-default:hover {\n  background-color: #e0e0e0;\n  background-position: 0 -15px;\n}\n.ez-toc-btn-default.active,\n.ez-toc-btn-default:active,\n.ez-toc-btn-default:focus,\n.ez-toc-btn-default:hover {\n  color: #333;\n  background-color: #ebebeb;\n  border-color: #adadad;\n}\n.ez-toc-btn:focus,\n.ez-toc-btn:hover {\n  color: #333;\n  text-decoration: none;\n}\n.ez-toc-btn:focus {\n  outline: #333 dotted thin;\n  outline: -webkit-focus-ring-color auto 5px;\n  outline-offset: -2px;\n}\na:focus,\na:hover {\n  text-decoration: underline;\n  color: var(--nv-secondary-accent);\n}\n.ez-toc-pull-right {\n  float: right !important;\n  margin-left: 10px;\n}\n.ez-toc-btn-xs {\n  padding: 1px 5px;\n}\n.ez-toc-btn-sm,\n.ez-toc-btn-xs {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n\n/* Video css */\nfigure.wp-block-video {\n  margin: 0px;\n}\n\n.wp-block-video video {\n  max-width: 760px;\n  object-fit: contain;\n  height: auto;\n}\n\n/* Image gallery css */\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  a,\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image)\n  img {\n  width: 100%;\n  flex: 1 0 0%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.wp-block-gallery.has-nested-images figure.wp-block-image img {\n  display: block;\n  height: auto;\n  max-width: 100% !important;\n  width: auto;\n}\n\n.wp-block-image.has-custom-border img,\n.wp-block-image img {\n  box-sizing: border-box;\n}\n.wp-block-image img {\n  height: auto;\n  max-width: 100%;\n  vertical-align: bottom;\n}\n\nhtml :where(img[class*=\"wp-image-\"]) {\n  height: auto;\n  max-width: 100%;\n}\n\n@media (min-width: 600px) {\n  .wp-block-gallery.has-nested-images.columns-default\n    figure.wp-block-image:not(#individual-image) {\n    width: calc(\n      33.33% - var(--wp--style--unstable-gallery-gap, 16px) * 0.66667\n    );\n  }\n}\n\n.wp-block-gallery.has-nested-images.is-cropped\n  figure.wp-block-image:not(#individual-image) {\n  align-self: inherit;\n}\n.wp-block-gallery.has-nested-images\n  figure.wp-block-image:not(#individual-image) {\n  width: calc(50% - var(--wp--style--unstable-gallery-gap, 16px) / 2);\n  margin: 0;\n}\n.wp-block-gallery.has-nested-images figure.wp-block-image {\n  display: flex;\n  flex-grow: 1;\n  justify-content: center;\n  position: relative;\n  flex-direction: column;\n  max-width: 100%;\n  box-sizing: border-box;\n}\nbody .is-layout-flex > * {\n  margin: 0;\n}\n\nfigure {\n  margin: 0 0 1em;\n}\n\nfigure.wp-block-gallery {\n  margin-bottom: 30px;\n}\n\nfigure.wp-block-gallery.has-nested-images {\n  align-items: normal;\n}\n\n.wp-block-gallery.wp-block-gallery-1 {\n  --wp--style--unstable-gallery-gap: var(\n    --wp--style--gallery-gap-default,\n    var(--gallery-block--gutter-size, var(--wp--style--block-gap, 0.5em))\n  );\n  gap: var(\n    --wp--style--gallery-gap-default,\n    var(--gallery-block--gutter-size, var(--wp--style--block-gap, 0.5em))\n  );\n}\n\nbody .is-layout-flex {\n  flex-wrap: wrap;\n  align-items: center;\n}\n\nbody .is-layout-flex {\n  display: flex;\n}\n\n/* Button css */\n.wp-block-themeisle-blocks-button-group.align-center-desktop,\n.wp-block-themeisle-blocks-button-group.align-center {\n  justify-content: center;\n}\n\n.wp-block-themeisle-blocks-button-group {\n  --padding: 16px 30px;\n  --padding-tablet: var(--padding);\n  --padding-mobile: var(--padding-tablet);\n  --font-size: var(--btnfs, var(--bodyfontsize, 16px));\n  --spacing: 20px;\n  gap: var(--spacing);\n}\n\n.wp-block-themeisle-blocks-button-group {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.wp-block-themeisle-blocks-button-group .wp-block-themeisle-blocks-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wp-block-buttons > .wp-block-button {\n  display: inline-block;\n  margin: 0;\n}\n\n.wp-block-themeisle-blocks-button-group\n  .wp-block-themeisle-blocks-button:is(.wp-block-button)\n  :is(div, span, a).wp-block-button__link {\n  padding: var(--padding);\n  font-size: var(--font-size);\n}\n\n/* .wp-block-button__link:not(:hover) {\n  background: var(--nv-primary-accent);\n} */\n\n.wp-block-button a {\n  text-decoration: none !important;\n}\n\n.wp-block-button__link {\n  color: #fff;\n  background-color: #32373c;\n  border-radius: 9999px;\n  box-shadow: none;\n  text-decoration: none;\n  text-decoration-line: none;\n  text-decoration-thickness: initial;\n  text-decoration-style: initial;\n  text-decoration-color: initial;\n  padding: calc(0.667em + 2px) calc(1.333em + 2px);\n  font-size: 1.125em;\n}\n\n.btn,\n.button,\n.wp-block-button a,\ninput[type=\"button\"],\ninput[type=\"submit\"] {\n  font-size: 0.8em;\n  font-weight: 600;\n  padding: 8px 12px;\n  transition: all 0.15s ease-in-out;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n  text-transform: uppercase;\n  cursor: pointer;\n  line-height: normal;\n  font-family: inherit;\n}\n\n.btn,\n.button,\n.wp-block-button a,\ninput[type=\"button\"],\ninput[type=\"submit\"] {\n  font-size: 0.8em;\n  font-weight: 600;\n  padding: 8px 12px;\n  transition: all 0.15s ease-in-out;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n  text-transform: uppercase;\n  cursor: pointer;\n  line-height: normal;\n  font-family: inherit;\n}\n\n.wp-block-button__link {\n  color: #fff;\n  background-color: #32373c;\n  border-radius: 9999px;\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n  box-shadow: none;\n  text-decoration: none;\n  padding: calc(0.667em + 2px) calc(1.333em + 2px);\n  font-size: 1.125em;\n}\n:where(.wp-block-button__link) {\n  border-radius: 9999px;\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n  box-shadow: none;\n  padding: calc(0.667em + 2px) calc(1.333em + 2px);\n  text-decoration: none;\n}\n\n.wp-block-themeisle-blocks-button-group\n  .wp-block-themeisle-blocks-button:is(.wp-block-button)\n  :is(div, span, a).wp-block-button__link {\n  padding: 16px 32px;\n}\n\n.wp-block-themeisle-blocks-button.wp-block-button {\n  margin: 20px;\n}\n\nimg.lazyload {\n  width: 100%;\n}\n\n/* Quick Answers FAQ Section Styling */\n/* Using stable class name to avoid MUI hash changes */\n.blog-post-content details {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  background: #fafafa;\n  transition: all 0.2s ease;\n}\n\n.blog-post-content details:hover {\n  border-color: #916db0;\n  box-shadow: 0 2px 8px rgba(145, 109, 176, 0.1);\n}\n\n.blog-post-content details[open] {\n  background: #ffffff;\n  border-color: #916db0;\n  box-shadow: 0 2px 12px rgba(145, 109, 176, 0.15);\n}\n\n.blog-post-content details summary {\n  cursor: pointer;\n  user-select: none;\n  list-style: none;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  color: #282828;\n  transition: color 0.2s ease;\n}\n\n/* Remove default disclosure triangle */\n.blog-post-content details summary::-webkit-details-marker {\n  display: none;\n}\n\n/* Custom expansion icon */\n.blog-post-content details summary::before {\n  content: \"▶\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 12px;\n  font-size: 12px;\n  color: #916db0;\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.blog-post-content details[open] summary::before {\n  transform: rotate(90deg);\n}\n\n.blog-post-content details summary:hover {\n  color: #916db0;\n}\n\n/* H3 inside summary should not have default margins */\n.blog-post-content details summary h3 {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  display: inline;\n}\n\n/* Content inside details (when expanded) */\n.blog-post-content details p,\n.blog-post-content details ul,\n.blog-post-content details ol {\n  margin-top: 12px;\n  margin-bottom: 8px;\n  padding-left: 32px;\n  color: #444;\n  line-height: 1.6;\n}\n\n.blog-post-content details ul,\n.blog-post-content details ol {\n  padding-left: 52px;\n}\n\n.blog-post-content details li {\n  margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
